import React from 'react';
import { Popper, Paper, IconButton, Typography, ClickAwayListener } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { usePopover } from '../contexts/PopoverContext';

interface CommonPopoverProps {
  id: string;
  content: string;
}

const CommonPopover: React.FC<CommonPopoverProps> = ({ id, content }) => {
  const { openId, anchorEl, closePopover } = usePopover();

  const handleClose = (e?: MouseEvent | TouchEvent | React.MouseEvent<HTMLElement>) => {
    if (e && 'stopPropagation' in e && typeof e.stopPropagation === 'function') {
      e.stopPropagation();
    }
    closePopover();
  };

  // Only render Popper if anchorEl is a valid HTMLElement and in the document
  const isValidAnchor = anchorEl instanceof HTMLElement && document.body.contains(anchorEl);
  if (!isValidAnchor) return null;

  return (
    <ClickAwayListener onClickAway={(e) => handleClose(e)}>
      <Popper
        open={openId === id}
        anchorEl={anchorEl}
        placement="bottom-end"
        modifiers={[{ name: 'offset', options: { offset: [0, 10] } }]}
      >
        <Paper
          elevation={3}
          onClick={(e) => e.stopPropagation()} 
          sx={{
            p: 2,
            pt: 3,
            maxWidth: 400,
            maxHeight: '55vh',
            overflowY: 'auto',
            fontFamily: 'Nunito Sans',
            position: 'relative',
            borderRadius: 1.5,
            '&::-webkit-scrollbar': {
              width: '6px',
            },
            // Firefox support
            scrollbarWidth: 'thin',
          }}
        >
          <IconButton
            size="small"
            onClick={handleClose}
            sx={{ position: 'absolute', top: 1, right: 1 }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
          <Typography sx={{ fontSize: '12px', whiteSpace: 'pre-wrap' }}>{content || 'Geen gegevens beschikbaar'}</Typography>
        </Paper>
      </Popper>
    </ClickAwayListener>
  );
};

export default CommonPopover;
